/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Select_DurationInputs */

const en_common_select_duration = /** @type {(inputs: Common_Select_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select duration`)
};

const es_common_select_duration = /** @type {(inputs: Common_Select_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona duración`)
};

/**
* | output |
* | --- |
* | "Select duration" |
*
* @param {Common_Select_DurationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_select_duration = /** @type {((inputs?: Common_Select_DurationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Select_DurationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_select_duration(inputs)
	return en_common_select_duration(inputs)
});